var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('transition-group',{staticClass:"win-feed d-flex",attrs:{"tag":"div","name":"t-win-feed-item"}},[_vm._l((_vm.feed),function(item){return _vm._t("default",[_c('WinFeedItem',{key:item.id,attrs:{"item":item}})],{"item":item})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }